import { render, staticRenderFns } from "./Referenti.vue?vue&type=template&id=66caa0f3&scoped=true&"
import script from "./Referenti.vue?vue&type=script&lang=js&"
export * from "./Referenti.vue?vue&type=script&lang=js&"
import style0 from "./Referenti.vue?vue&type=style&index=0&id=66caa0f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66caa0f3",
  null
  
)

export default component.exports